import withResponsive from '../hoc/withResponsive'
import onResize from '../utils/onResize'
import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules'
import 'swiper/css'

export default withResponsive({
  name: 'slider',

  ui: {
    pagination: '[js-slider-pagination]',
    navigation: '[js-slider-navigation]',
    slider: '[js-slider-el]',
    'bg[]': '[js-slider-bg]',
    currentSlide: '[js-slider-current-slide]',
    reset: '[js-slider-reset]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.props.options.modules = [Navigation, Pagination, EffectFade, Autoplay]

    this.options = {
      threshold: 30,
    }

    if (this.ui.pagination) {
      this.props.options.pagination = {
        el: this.ui.pagination,
        type: 'bullets',
      }
    }

    // Find the nav that belongs to this slider (not one nested inside a slide's own swiper)
    this.navEl = this.ui.slider
      ? ([...this.el.querySelectorAll('[js-slider-navigation]')].find(n => !this.ui.slider.contains(n)) || null)
      : null

    if (this.navEl) {
      this.props.options.navigation = {
        nextEl: this.navEl.querySelector('.swiper-button-next'),
        prevEl: this.navEl.querySelector('.swiper-button-prev'),
      }
    }

    this.options = { ...this.options, ...this.props.options }

    this.slider = new Swiper(this.ui.slider, this.options)

    // Fix iOS Safari : viewport instable au premier rendu
    setTimeout(() => {
      if (this.slider) this.slider.update()
    }, 300)

    if (this.slider && this.slider.slides !== undefined) {
      this.checkDisable()
    }

    if (this.ui.bg.length > 0) {
      this.slider.on('slideChangeTransitionEnd', () => {
        const currentIndex = this.el.querySelector('.swiper-slide-active').dataset.index
        this.el.querySelector('[js-slider-bg].is-active').classList.remove('is-active')
        this.el.querySelector(`[js-slider-bg][data-index="${currentIndex}"]`).classList.add('is-active')
      })
    }

    if (this.ui.reset) {
      this.ui.reset.addEventListener('click', () => {
        this.slider.slideTo(0)
      })
    }

    if (this.ui.currentSlide) {
      this.slider.on('slideChangeTransitionEnd', () => {
        const index = this.slider.realIndex + 1
        this.ui.currentSlide.innerHTML = index < 10 ? `0${index}` : index
      })
    }
    
    this.slider.on('slideChange', function (swiper) {
      window.emitterSingleton.trigger('slideChange', swiper);
    })

    window.emitterSingleton.on('slideTo', (params) => {
      if (this.props.id && this.props.id === params.id) {
        this.slider.slideTo(params.index);
      }
    })
  },

  componentWillUnmount () {
    this.off()

    this.slider.destroy()
    if (this.ui.pagination) this.ui.pagination.innerHTML = ''
  },

  onResize () {
    if (this.slider && this.slider.slides !== undefined) {
      setTimeout(() => {
        this.slider.update()
        this.checkDisable()
      }, 500)
    }
  },

  checkDisable () {
    if (this.slider.slides !== 'undefined') {
      const nbSlides = this.slider.slides.length

      if (window.innerWidth < 768 && nbSlides < 2) {
        if (typeof this.options.allowTouchMove === 'undefined' || this.options.allowTouchMove) this.slider.allowTouchMove = false
        if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
      } else {
        if (typeof this.options.allowTouchMove === 'undefined' || this.options.allowTouchMove) this.slider.allowTouchMove = true
        if (this.ui.pagination) this.ui.pagination.classList.remove('is-hidden')
      }

      if (this.props.options.breakpoints) {
        Object.entries(this.props.options.breakpoints).forEach((breakpoint) => {
          if (window.innerWidth >= breakpoint[0]) {
            if (nbSlides / breakpoint[1].slidesPerView <= 1) {
              this.slider.allowTouchMove = false
              if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
              if (this.navEl) this.navEl.classList.add('is-hidden')
            }
            if (typeof breakpoint[1].allowTouchMove !== 'undefined') {
              this.slider.allowTouchMove = breakpoint[1].allowTouchMove
            }
          } else {
            this.slider.allowTouchMove = true
            if (this.ui.pagination) {
              this.ui.pagination.classList.remove('is-hidden')
            }
            if (this.navEl) this.navEl.classList.remove('is-hidden')
          }
        })
      }
    }
  },
})
